const formatDate = (dateString) =>
  dateString
    ? new Date(dateString).toLocaleDateString("en-GB", { year: "numeric" })
    : "Present";

const formatDateRange = (startDateString, endDateString) => {
  const startDate = formatDate(startDateString);
  const endDate = formatDate(endDateString);
  return `${startDate} - ${endDate}`;
};

export const formatExperience = (exp) => ({
  title: exp.company,
  subtitle: exp.role,
  dateRange: formatDateRange(exp.startedAt, exp.endedAt),
  description: exp.description,
});

const formatDegreeAndField = (degree, field) =>
  degree && field ? `${degree}, ${field}` : degree || field || "";

export const formatEducation = (edu) => ({
  title: edu.school,
  subtitle: formatDegreeAndField(edu.degree, edu.field),
  dateRange: formatDateRange(edu.startedAt, edu.endedAt),
  description: edu.description,
});
